import { useState, useEffect } from 'react'
import { LoadingInsertImages, InsertImageGrid } from 'components'
import Flex from 'components/priority/Flex/Flex'
import { displayImageUrlsSelector } from '@/atoms/caseImageAtoms'
import { useRecoilValue } from 'recoil'

export const PhotosOfDeceasedMenu = ({ setShow }) => {
  const displayImageUrls = useRecoilValue(displayImageUrlsSelector)
  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState([])

  const sanitize = (data) => {
    return data.map((image) => ({
      name: '',
      image: image,
    }))
  }

  const getItems = () => {
    setLoading(true)
    setItems(sanitize(displayImageUrls))
    setLoading(false)
  }

  useEffect(() => {
    if (displayImageUrls.length > 0) {
      getItems()
    } else {
      setItems([])
      setLoading(false)
    }
    // eslint-disable-next-line
  }, [displayImageUrls])

  return loading ? (
    <LoadingInsertImages />
  ) : (
    <Flex full center padding="8px 0 0 0">
      {/* TODO: add 'make default' button */}
      <InsertImageGrid
        items={items}
        prependPrefix={false}
        imageKey="image"
        nameKey="name"
        type="caseImage"
        setShow={setShow}
        canDelete
      />
    </Flex>
  )
}

export default PhotosOfDeceasedMenu
